import { createSelector } from '@ngrx/store';

import { selectTrailersState, trailerGroupsAdapter } from '@store/trailers/trailers.state';

/**
 * Селектор для получения состояния списка групп прицепов.
 */
export const selectTrailerGroupsState = createSelector(
  selectTrailersState,
  (state) => state.groupsList,
);

const { selectAll, selectEntities, selectIds } =
  trailerGroupsAdapter.getSelectors(selectTrailerGroupsState);

/**
 * Селектор для получения всех групп прицепов.
 */
export const selectAllTrailerGroups = selectAll;

/**
 * Селектор для получения сущностей групп прицепов.
 */
export const selectTrailerGroupsEntities = selectEntities;

/**
 * Селектор для получения идентификаторов групп прицепов.
 */
export const selectTrailerGroupsIds = selectIds;

/**
 * Селектор для получения состояния загрузки списка групп прицепов.
 */
export const selectLoadingTrailersGroupsList = createSelector(
  selectTrailersState,
  (state) => state.loading,
);

/**
 * Селектор для получения группы прицепов по идентификатору.
 *
 * @param {number} id - Идентификатор группы прицепов.
 */
export const selectTrailerGroupById = (id: number) =>
  createSelector(selectTrailerGroupsEntities, (entities) => entities[id]);
